import { type MetaFunction } from '@remix-run/node'
import { useLoaderData } from '@remix-run/react'
import { useMemo } from 'react'
import PageHeader from '@/components/_sections/page-header.tsx'
import Sections from '@/components/_sections/sections.tsx'
import { loaderFunction } from '@/libs/strapi/pageLoader.ts'
import { useRootLoaderData } from '@/root.tsx'
import { ApiPagePage } from '@/types/contentTypes'

export const loader = loaderFunction

export const meta: MetaFunction<typeof loader> = (all) => {
	return [
		{
			title: all.data ? all.data.page : 'Error | Paul Fleming Restaurant Group',
		},
		{ name: 'description', content: `Home` },
	]
}

export default function Index() {
	const loaderData = useLoaderData()
	const { group } = useRootLoaderData()

	const pageData: ApiPagePage['attributes'] = loaderData.pageData
	const page: string = loaderData.page
	// const background = pageData.page_header_background || null

	const sections = useMemo(() => pageData?.sections ?? [], [page])

	if (!pageData)
		return <div>Trouble fetching page content please try again.</div>
	console.log(pageData)
	return (
		<>
			<PageHeader content={pageData} />
			<Sections sections={sections} />
		</>
	)
}
